import EmojiEventsRounded from "@mui/icons-material/EmojiEventsRounded";
import LeaderboardRounded from "@mui/icons-material/LeaderboardRounded";
import PersonRounded from "@mui/icons-material/PersonRounded";
import { Alert, List, Stack, Typography } from "@mui/material";
import { useAuth } from "@bw/shared/hooks";
import { NavRow } from "../../../common/components/NavRow";
import { Page } from "../../../common/components/Page";
import { SectionHeader } from "../../../common/components/SectionHeader";
import { RatingCard } from "../components/RatingCard";
import { StatsPanel } from "../components/StatsPanel";
import { AchievementList } from "../components/AchievementList";
import { MatchList } from "../components/MatchList";
import { useMyRating } from "../hooks/useMyRating";
import { useMyStats } from "../hooks/useMyStats";
import { useAchievements } from "../hooks/useAchievements";
import { useMatchHistory } from "../hooks/useMatchHistory";

export function PerformancePage() {
  const { user } = useAuth();
  const rating = useMyRating(Boolean(user));
  const stats = useMyStats();
  const achievements = useAchievements(user?.uid);
  const history = useMatchHistory({ limit: 5 });
  return (
    <Page title="Performance" hideTitle narrow>
      {rating.isError ? (
        <Alert severity="error">Could not load your rating.</Alert>
      ) : rating.isLoading ? (
        <Typography role="status" color="text.secondary">Loading rating…</Typography>
      ) : rating.data ? (
        <RatingCard rating={rating.data} showName={false} />
      ) : null}
      {stats.isError ? (
        <Alert severity="error">Could not load your statistics.</Alert>
      ) : stats.isLoading ? (
        <Typography role="status" color="text.secondary">Loading statistics…</Typography>
      ) : stats.data ? (
        <StatsPanel stats={stats.data} />
      ) : null}
      <Stack component="section" spacing={0.5} aria-labelledby="recent-matches-heading">
        <SectionHeader
          id="recent-matches-heading"
          title="Recent matches"
          action={{ label: "History", to: "/me/performance/matches", ariaLabel: "Match history" }}
        />
        {history.isError ? (
          <Alert severity="error">Could not load recent matches.</Alert>
        ) : history.isLoading ? (
          <Typography role="status" color="text.secondary">Loading matches…</Typography>
        ) : history.data?.length ? (
          <MatchList matches={history.data} viewerId={user?.uid ?? null} />
        ) : (
          <Typography variant="body2" color="text.secondary">No matches yet.</Typography>
        )}
      </Stack>
      {achievements.isError ? (
        <Alert severity="error">Could not load achievements.</Alert>
      ) : achievements.data ? (
        <AchievementList achievements={achievements.data} allTo="/me/achievements" />
      ) : null}
      <nav aria-label="Performance destinations">
        <List disablePadding>
          <NavRow icon={<LeaderboardRounded />} label="Rankings" to="/rankings" />
          <NavRow icon={<EmojiEventsRounded />} label="Achievements & streaks" to="/me/achievements" />
          {user ? (
            <NavRow icon={<PersonRounded />} label="Public profile" to={`/players/${user.uid}`} />
          ) : null}
        </List>
      </nav>
    </Page>
  );
}
